import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 25,
	fill: "none",
	viewBox: "0 0 24 25",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#0E1318",
			d: "M12 22.185c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#_1241036444__a)",
			d: "M12 22.185c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#_1241036444__b)",
			d: "M12 22.185c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#_1241036444__c)",
			d: "M12 22.185c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#_1241036444__d)",
			d: "M12 22.185c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M16.317 14.235c-.082 0-.155.07-.23.222-.854 1.73-2.328 2.955-4.034 2.955-1.972 0-3.194-1.78-3.194-4.24 0-4.167 2.322-6.576 4.36-6.576.954 0 1.536.6 1.536 1.552 0 1.13-.643 1.73-.643 2.128 0 .18.112.288.332.288.888 0 1.93-1.02 1.93-2.46 0-1.396-1.216-2.423-3.255-2.423-3.37 0-6.365 3.124-6.365 7.447 0 3.346 1.91 5.557 4.859 5.557 3.129 0 4.938-3.113 4.938-4.123 0-.224-.114-.327-.234-.327"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "_1241036444__a",
				cx: 0,
				cy: 0,
				r: 1,
				gradientTransform: "rotate(-49.416 24.569 3.585)scale(15.4682)",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6420FF" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#6420FF",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "_1241036444__b",
				cx: 0,
				cy: 0,
				r: 1,
				gradientTransform: "rotate(54.703 -.663 9.28)scale(17.4434)",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#00C4CC" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#00C4CC",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "_1241036444__c",
				cx: 0,
				cy: 0,
				r: 1,
				gradientTransform: "matrix(10.76839 -10.84209 4.98644 4.95254 5.863 19.911)",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6420FF" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#6420FF",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "_1241036444__d",
				cx: 0,
				cy: 0,
				r: 1,
				gradientTransform: "rotate(66.52 1.369 10.2)scale(15.7459 26.3778)",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#00C4CC" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#00C4CC",
					stopOpacity: 0
				})]
			})
		] })
	]
});
export default SvgIcon;
